import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { RumioSessionProvider } from "./lib/session";
import { IframeLayout } from "./components/IframeLayout";
import { ROUTES } from "./routes";
import { startVersionWatch } from "./lib/version-watch";
import { Toaster } from "sonner";
import "./styles/globals.css";

const NotFound = lazy(() => import("./pages/NotFound"));

function RouteFallback() {
  return (
    <div className="p-6 text-sm text-gray-500" aria-busy="true">
      Loading…
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RumioSessionProvider>
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            {ROUTES.filter((r) => r.bare).map((r) => (
              <Route key={r.path} path={r.path} element={r.element} />
            ))}
            <Route element={<IframeLayout />}>
              <Route path="/" element={<Navigate to="/home" replace />} />
              {ROUTES.filter((r) => !r.bare).map((r) => (
                <Route key={r.path} path={r.path} element={r.element} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RumioSessionProvider>
  </React.StrictMode>
);

// Watch for a newer deploy of this app while embedded in the Rumio host
// (apps platform contract v1.13).
startVersionWatch();
